import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck, Clock, Warehouse, Phone } from "lucide-react";
import { HOME_IMAGES } from "@/data/images";

const benefits = [
  { icon: ShieldCheck, t: "Safe Handling", d: "Every shipment secured to the highest standards." },
  { icon: Clock, t: "On-Time Every Time", d: "Reliable pickups and deliveries you can plan around." },
  { icon: Warehouse, t: "Right-Sized Fleet", d: "Trucks matched to your load — no wasted capacity." },
  { icon: Phone, t: "Real Communication", d: "Direct line to dispatch, never a chatbot maze." },
];

export function WhyChooseUs() {
  return (
    <section className="relative py-24 lg:py-32 border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="relative"
        >
          <img src={HOME_IMAGES.fleet} alt="Fleet" className="w-full h-[520px] object-cover" />
          <div className="absolute -bottom-6 -right-6 bg-primary-brand text-white p-6 max-w-[240px]">
            <div className="font-heading text-3xl font-black">On-Time</div>
            <div className="text-xs uppercase tracking-[0.2em] mt-1">
              Every pickup. Every delivery.
            </div>
          </div>
        </motion.div>
        <div>
          <div className="text-xs tracking-[0.3em] uppercase font-bold text-primary-brand mb-3">
            Why Laronta Pro
          </div>
          <h2 className="font-heading text-4xl md:text-5xl font-black tracking-tight mb-8">
            Peace of mind, from pickup to drop-off.
          </h2>
          <div className="space-y-5">
            {benefits.map((b, i) => (
              <motion.div
                key={b.t}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.06 }}
                className="flex items-start gap-4 py-4 border-b border-slate-200"
              >
                <div className="h-10 w-10 flex items-center justify-center bg-white border border-slate-200">
                  <b.icon className="h-5 w-5 text-primary-brand" />
                </div>
                <div>
                  <div className="font-heading font-bold text-lg">{b.t}</div>
                  <div className="text-sm text-slate-600">{b.d}</div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
